import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import {
  HeaderH2,
  HeaderH1,
  Text,
  NextButton,
  ImageBlock,
  HeaderH3,
} from "components/TextBlocks";

function Themes(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Settings</HeaderH1>
      <ImageBlock
        src={"/guide/dark_mode.png"}
        width={504}
        height={508}
        alt={"Dark mode switch"}
      />
      <Text>In settings you find these options:</Text>
      <HeaderH3 id="Editspaces">• FX sounds</HeaderH3>
      <Text>Turn off and on sound effects.</Text>
      <HeaderH3 id="Editspaces">• Light/Dark mode</HeaderH3>
      <Text>Choose between light and dark mode.</Text>
      <HeaderH3 id="Editspaces">• Clear thumbnails</HeaderH3>
      <Text>
        Clears out the thumbnail that you see when hovering your active tabs.
        The thumbnail is captured once a page is fully reloaded. The thumbnails
        are self-destroyed once they are not in the active tabs lists anymore.
      </Text>
      <HeaderH3 id="Editspaces">• Export data</HeaderH3>
      <Text>
        Exports your current data as a JSON file(JSON is a lightweight format
        for storing and transporting data). Once exported the file will be
        located in your download folder.
      </Text>
    </>
  );
}

Themes.Layout = SideBar;

export default Themes;
